import React from 'react';

import { Link, graphql, useStaticQuery } from 'gatsby';

import { GatsbyImage, getImage } from "gatsby-plugin-image";

function MainBanner({ text }) {
    const data = useStaticQuery(graphql`
    query MainLogo {
        imageSharp {
          gatsbyImageData(height: 47, sizes: "", width: 182, formats: NO_CHANGE)
        }
      }
    `)
    const image = getImage(data.imageSharp.gatsbyImageData)
    return (
        <div className="w-full h-screen bg-main-banner bg-cover">
            <div className="relative w-full h-full bg-gray-800 bg-opacity-90 flex flex-col justify-center items-center">
                <div className="mb-8 bg-white p-2 rounded">
                    <GatsbyImage image={image} alt={'Logo Hairzig'} />
                </div>
                <div className="text-white font-bold md:text-2xl mb-8">
                    { text }
                </div>
                <div className="flex flex-col md:flex-row md:space-x-8">
                    <button 
                        onClick={() => {
                            window.wahanda.openOnlineBookingWidget('https://buchung.treatwell.at/ort/394474/menue')
                            return false;
                        }}
                        className="w-full outline-white p-2 rounded text-white font-bold">Termin Buchen</button>
                </div>
                <button className="font-bold rounded bg-red-500 text-white p-2 absolute bottom-4 right-4">
                    <Link to="/about">Mehr erfahren</Link>
                </button>
            </div>
        </div>
    );
}

export default MainBanner;